import { useEffect, useState } from "react";
import { getProgramsHierachy } from "@/shared/apiHelper";

let cachedPrograms = null;

export const usePrograms = (organizationId) => {
  const [programs, setPrograms] = useState(cachedPrograms || []);
  const [loading, setLoading] = useState(!cachedPrograms);

  useEffect(() => {
    if (!organizationId) return;

    if (cachedPrograms) {
      setPrograms(cachedPrograms);
      return;
    }

    setLoading(true);

    getProgramsHierachy(organizationId)
      .then((res) => {
        const data = res?.data || res || [];
        cachedPrograms = data;
        setPrograms(data);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [organizationId]);

  return { programs, loading };
};
